import React, {Component, ReactElement} from 'react'
import FacilitiesRepository from '../components/facilities/FacilitiesRepository'
import Http from '../network/Http'
import {BrowserRouter, matchPath, Navigate, useLocation} from 'react-router-dom'
import ReservationsRepository from '../components/reservations/ReservationsRepository'
import AdminAuthRepository from '../__NoAutomatedTests/components/login/repository/AdminAuthRepository'
import GlobalConfig from './GlobalConfig'
import {EquipmentsRepository} from '../components/equipments/EquipmentsRepository'
import AppAdmin from './AppAdmin'
import AppResident from './AppResident'
import {ScrollToTop} from './ScrollToTop'
import {LocalizationProvider} from '@mui/x-date-pickers'
import HolidaysRepository from '../components/HolidaysRepository'
import NatCondominiumRepo from '../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import NatAdminUserRepo from '../__NoAutomatedTests/components/adminUser/repository/NatAdminUserRepo'
import NatResidentUserRepo from '../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo'
import NatRoomToResidentRepo from '../__NoAutomatedTests/components/roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumGroupRepo
    from '../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import NatScheduleRepo from '../__NoAutomatedTests/components/schedule/repository/NatScheduleRepo'
import NatEventRepo from '../__NoAutomatedTests/components/event/repository/NatEventRepo'
import NatRidgeRepo from '../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import NatRoomNumberRepo from '../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import NatTokenRepo from '../__NoAutomatedTests/components/token/repository/NatTokenRepo'
import NatPasswordRepo from '../__NoAutomatedTests/components/password/repository/NatPasswordRepo'
import NatMessageRepo from '../__NoAutomatedTests/components/message/repository/NatMessageRepo'
import NatCurrentDateTimeRepo from '../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import NatHolidayMasterRepo from '../__NoAutomatedTests/components/holiday/repository/NatHolidayMasterRepo'
import NatLifeNoteRepo from '../__NoAutomatedTests/components/lifeNote/repository/NatLifeNoteRepo'
import NatLoginRepo from '../__NoAutomatedTests/components/login/repository/NatLoginRepo'
import NatSessionRepo from '../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import NatLoginBeforeMessageRepo
    from '../__NoAutomatedTests/components/loginBeforeMessage/repository/NatLoginBeforeMessageRepo'
import NatMenuMasterRepo from '../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import NatUseFunctionMasterRepo
    from '../__NoAutomatedTests/components/useFunctionMaster/repository/NatUseFunctionMasterRepo'
import NatClosedSettingRepo from '../__NoAutomatedTests/components/closedSetting/repository/NatClosedSettingRepo'
import NatCondominiumAuthoritySettingRepo
    from '../__NoAutomatedTests/components/condominiumAuthoritySetting/repository/NatCondominiumAuthoritySettingRepo'
import NatOwnerCondominiumRepo
    from '../__NoAutomatedTests/components/ownerCondominium/repository/NatOwnerCondominiumRepo'
import NatApartAssocInfoRepo from '../__NoAutomatedTests/components/apartAssocInfo/repository/NatApartAssocInfoRepo'
import NatFacilityRepo from '../__NoAutomatedTests/components/facility/repository/NatFacilityRepo'
import NatFacilityReserveRepo from '../__NoAutomatedTests/components/facilityReserve/repository/NatFacilityReserveRepo'
import CondominiumsRepository from '../components/condominiums/CondominiumsRepository'
import {ReservationsRepositoryForAdmin} from '../components/reservations/admin/ReservationsRepositoryForAdmin'
import AdminUserRepository from '../components/adminUser/AdminUserRepository'
import jaLocale from 'date-fns/locale/ja'
import {ExtendedDateFnsUtilsUtils} from '../DateFnsUtils'
import NatBulletinBoardRepo from '../__NoAutomatedTests/components/bulletinBoard/repository/NatBulletinBoardRepo'
import {PersonalInfoExtractHistoryRepo} from '../components/PersonalInfoExtractHistoryRepo'
import NatAreaCodeRepo from '../__NoAutomatedTests/components/areaCode/repository/NatAreaCodeRepo'
import NatEnvSettingRepo from '../__NoAutomatedTests/components/envSetting/repository/NatEnvSettingRepo'
import NatSsoRepo from '../__NoAutomatedTests/components/sso/repository/NatSsoRepo'
import NatMaintenanceSettingMasterRepo
    from '../__NoAutomatedTests/components/maintenance/repository/NatMaintenanceSettingMasterRepo'
import NatExtractHistoryRepo from '../__NoAutomatedTests/components/extract/repository/NatExtractHistoryRepo'
import NatCommunicationPlatformRepo
    from '../__NoAutomatedTests/components/communicationPlatform/repository/NatCommunicationPlatformRepo'
import {MeetingRepositoryForAdmin} from '../components/assocDirector/MeetingRepositoryForAdmin'
import {MeetingRepositoryForResident} from '../components/assocDirector/MeetingRepositoryForResident'
import {
    AdminNotificationReceiveSettingRepo,
} from '../components/notificationReceiveSetting/AdminNotificationReceiveSettingRepo'
import AssocDirectorRepository from '../components/assocDirector/AssocDirectorRepository'
import AssocManagementRepository from '../components/assocDirector/AssocManagementRepository'
import {NatApplicationRepo} from '../__NoAutomatedTests/components/applications/repository/NatApplicationRepo'
import {NatFileRepo} from '../__NoAutomatedTests/components/files/repository/NatFileRepo'
import {
    NatAssocWorkReportRepo,
} from '../__NoAutomatedTests/components/assocWorkReports/repository/NatAssocWorkReportRepo'
import {
    NatOwnershipTransfersRepo,
} from '../__NoAutomatedTests/components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import AppGuest from './AppGuest'
import NatGuestLoginRepo from '../__NoAutomatedTests/components/login/repository/NatGuestLoginRepo'
import NatCampaignRepo from '../__NoAutomatedTests/components/campaigns/repository/NatCampainRepo'
import {NatTwoFactorAuthRepo} from '../__NoAutomatedTests/components/twoFactorAuth/repository/NatTwoFactorAuthRepo'
import {NoSsr} from '@mui/material'
import NatAuthorityRepo from '../__NoAutomatedTests/components/authority/repository/NatAuthorityRepo';
import NatResidentBankAccountInfoRepo
    from '../__NoAutomatedTests/components/accountTransfer/repository/NatResidentBankAccountInfoRepo'
import NatAmountFixRepo
    from '../__NoAutomatedTests/components/AmountFix/repository/NatAmountFixRepo';
import NatSutekiNetPlusRepo from '../__NoAutomatedTests/components/mypage/repository/NatSutekiNetPlusRepo'
import NatDisasterRepo from '../__NoAutomatedTests/components/disaster/repository/NatDisasterRepo'
import ResidentGeneralMeetingRepo from '../components/generalMeeting/ResidentGeneralMeetingRepo'
import AdminGeneralMeetingRepo from '../components/generalMeeting/AdminGeneralMeetingRepo'

export default class App extends Component {
    private readonly condominiumsRepo: CondominiumsRepository
    private readonly facilitiesRepo: FacilitiesRepository
    private readonly reservationsRepo: ReservationsRepository
    private readonly reservationsRepoForAdmin: ReservationsRepositoryForAdmin
    private readonly adminAuthRepo: AdminAuthRepository
    private readonly equipmentsRepo: EquipmentsRepository
    private readonly holidaysRepo: HolidaysRepository
    private readonly meetingRepoForAdmin: MeetingRepositoryForAdmin
    private readonly meetingRepoForResident: MeetingRepositoryForResident
    private readonly adminNotificationReceiveSettingRepo: AdminNotificationReceiveSettingRepo
    private readonly natCondominiumRepo: NatCondominiumRepo
    private readonly natAdminUserRepo: NatAdminUserRepo
    private readonly natResidentUserRepo: NatResidentUserRepo
    private readonly natRoomToResidentRepo: NatRoomToResidentRepo
    private readonly natCondominiumGroupRepo: NatCondominiumGroupRepo
    private readonly natScheduleRepo: NatScheduleRepo
    private readonly natEventRepo: NatEventRepo
    private readonly natRidgeRepo: NatRidgeRepo
    private readonly natRoomNumberRepo: NatRoomNumberRepo
    private readonly natTokenRepo: NatTokenRepo
    private readonly natPasswordRepo: NatPasswordRepo
    private readonly natMessageRepo: NatMessageRepo
    private readonly natCurrentDateTimeRepo: NatCurrentDateTimeRepo
    private readonly natHolidayMasterRepo: NatHolidayMasterRepo
    private readonly natLifeNoteRepo: NatLifeNoteRepo
    private readonly natLoginRepo: NatLoginRepo
    private readonly natSessionRepo: NatSessionRepo
    private readonly natLoginBeforeMessageRepo: NatLoginBeforeMessageRepo
    private readonly natMenuMasterRepo: NatMenuMasterRepo
    private readonly natUseFunctionMasterRepo: NatUseFunctionMasterRepo
    private readonly natClosedSettingRepo: NatClosedSettingRepo
    private readonly natCondominiumAuthoritySettingRepo: NatCondominiumAuthoritySettingRepo
    private readonly natOwnerCondominiumRepo: NatOwnerCondominiumRepo
    private readonly natApartAssocInfoRepo: NatApartAssocInfoRepo
    private readonly natFacilityRepo: NatFacilityRepo
    private readonly adminUserRepo: AdminUserRepository
    private readonly natFacilityReserveRepo: NatFacilityReserveRepo
    private readonly natBulletinBoardRepo: NatBulletinBoardRepo
    private readonly personalInfoExtractHistoryRepo: PersonalInfoExtractHistoryRepo
    private readonly natAreaCodeRepo: NatAreaCodeRepo
    private readonly natEnvSettingRepo: NatEnvSettingRepo
    private readonly natSsoRepo: NatSsoRepo
    private readonly natMaintenanceSettingMasterRepo: NatMaintenanceSettingMasterRepo
    private readonly natExtractHistoryRepo: NatExtractHistoryRepo
    private readonly natCommunicationPlatformRepo: NatCommunicationPlatformRepo
    private readonly assocManagementRepo: AssocManagementRepository
    private readonly assocDirectorRepository: AssocDirectorRepository
    private readonly applicationRepo: NatApplicationRepo
    private readonly fileRepo: NatFileRepo
    private readonly assocWorkReportRepo: NatAssocWorkReportRepo
    private readonly ownershipTransfersRepo: NatOwnershipTransfersRepo
    private readonly natGuestLoginRepo: NatGuestLoginRepo
    private readonly campaignRepo: NatCampaignRepo
    private readonly natTwoFactorAuthRepo: NatTwoFactorAuthRepo
    private readonly residentUserRepo: NatResidentUserRepo
    private readonly natAuthorityRepo: NatAuthorityRepo
    private readonly bankAccountInfoRepo: NatResidentBankAccountInfoRepo
    private readonly billingAmountFixInfoRepo: NatAmountFixRepo
    private readonly useFunctionMasterRepo:NatUseFunctionMasterRepo
    private readonly sutekiNetPlusRepo: NatSutekiNetPlusRepo
    private readonly disasterRepo: NatDisasterRepo
    private readonly residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
    private readonly adminGeneralMeetingRepo: AdminGeneralMeetingRepo

    constructor(props: object) {
        super(props)

        GlobalConfig.configure()

        const http: Http = new Http()
        this.condominiumsRepo = new CondominiumsRepository(http)
        this.facilitiesRepo = new FacilitiesRepository(http)
        this.reservationsRepo = new ReservationsRepository(http)
        this.reservationsRepoForAdmin = new ReservationsRepositoryForAdmin(http)
        this.adminAuthRepo = new AdminAuthRepository(http)
        this.equipmentsRepo = new EquipmentsRepository(http)
        this.holidaysRepo = new HolidaysRepository(http)
        this.meetingRepoForAdmin = new MeetingRepositoryForAdmin(http)
        this.meetingRepoForResident = new MeetingRepositoryForResident(http)
        this.adminNotificationReceiveSettingRepo = new AdminNotificationReceiveSettingRepo(http)
        this.natCondominiumRepo = new NatCondominiumRepo(http)
        this.natAdminUserRepo = new NatAdminUserRepo(http)
        this.natResidentUserRepo = new NatResidentUserRepo(http)
        this.natRoomToResidentRepo = new NatRoomToResidentRepo(http)
        this.natCondominiumGroupRepo = new NatCondominiumGroupRepo(http)
        this.natScheduleRepo = new NatScheduleRepo(http)
        this.natEventRepo = new NatEventRepo(http)
        this.natRidgeRepo = new NatRidgeRepo(http)
        this.natRoomNumberRepo = new NatRoomNumberRepo(http)
        this.natTokenRepo = new NatTokenRepo(http)
        this.natPasswordRepo = new NatPasswordRepo(http)
        this.natMessageRepo = new NatMessageRepo(http)
        this.natCurrentDateTimeRepo = new NatCurrentDateTimeRepo(http)
        this.natHolidayMasterRepo = new NatHolidayMasterRepo(http)
        this.natLifeNoteRepo = new NatLifeNoteRepo(http)
        this.natLoginRepo = new NatLoginRepo(http)
        this.natSessionRepo = new NatSessionRepo(http)
        this.natLoginBeforeMessageRepo = new NatLoginBeforeMessageRepo(http)
        this.natMenuMasterRepo = new NatMenuMasterRepo(http)
        this.natUseFunctionMasterRepo = new NatUseFunctionMasterRepo(http)
        this.natClosedSettingRepo = new NatClosedSettingRepo(http)
        this.natCondominiumAuthoritySettingRepo = new NatCondominiumAuthoritySettingRepo(http)
        this.natOwnerCondominiumRepo = new NatOwnerCondominiumRepo(http)
        this.natApartAssocInfoRepo = new NatApartAssocInfoRepo(http)
        this.natFacilityRepo = new NatFacilityRepo(http)
        this.adminUserRepo = new AdminUserRepository(http)
        this.natFacilityReserveRepo = new NatFacilityReserveRepo(http)
        this.natBulletinBoardRepo = new NatBulletinBoardRepo(http)
        this.personalInfoExtractHistoryRepo = new PersonalInfoExtractHistoryRepo(http)
        this.natAreaCodeRepo = new NatAreaCodeRepo(http)
        this.natEnvSettingRepo = new NatEnvSettingRepo(http)
        this.natSsoRepo = new NatSsoRepo(http)
        this.natMaintenanceSettingMasterRepo = new NatMaintenanceSettingMasterRepo(http)
        this.natExtractHistoryRepo = new NatExtractHistoryRepo(http)
        this.natCommunicationPlatformRepo = new NatCommunicationPlatformRepo(http)
        this.assocManagementRepo = new AssocManagementRepository(http)
        this.assocDirectorRepository = new AssocDirectorRepository(http)
        this.applicationRepo = new NatApplicationRepo(http)
        this.fileRepo = new NatFileRepo(http)
        this.assocWorkReportRepo = new NatAssocWorkReportRepo(http)
        this.ownershipTransfersRepo = new NatOwnershipTransfersRepo(http)
        this.natGuestLoginRepo = new NatGuestLoginRepo(http)
        this.campaignRepo = new NatCampaignRepo(http)
        this.natTwoFactorAuthRepo = new NatTwoFactorAuthRepo(http)
        this.residentUserRepo = new NatResidentUserRepo(http)
        this.natAuthorityRepo = new NatAuthorityRepo(http)
        this.bankAccountInfoRepo = new NatResidentBankAccountInfoRepo(http)
        this.billingAmountFixInfoRepo = new NatAmountFixRepo(http)
        this.useFunctionMasterRepo = new NatUseFunctionMasterRepo((http))
        this.sutekiNetPlusRepo = new NatSutekiNetPlusRepo(http)
        this.disasterRepo = new NatDisasterRepo(http)
        this.residentGeneralMeetingRepo = new ResidentGeneralMeetingRepo(http)
        this.adminGeneralMeetingRepo = new AdminGeneralMeetingRepo(http)
    }

    AppSelector: React.FC = () => {
        const location = useLocation()

        const renderApp = () => {
            if (matchPath({path: '/admin', end: false}, location.pathname)) {
                return (
                    <AppAdmin
                        facilitiesRepo={this.facilitiesRepo}
                        reservationsRepo={this.reservationsRepo}
                        reservationsRepoForAdmin={this.reservationsRepoForAdmin}
                        adminAuthRepo={this.adminAuthRepo}
                        equipmentsRepo={this.equipmentsRepo}
                        meetingRepoForAdmin={this.meetingRepoForAdmin}
                        adminNotificationReceiveSettingRepo=
                            {this.adminNotificationReceiveSettingRepo}
                        natTokenRepo={this.natTokenRepo}
                        natCondominiumRepo={this.natCondominiumRepo}
                        natAdminUserRepo={this.natAdminUserRepo}
                        natRoomToResidentRepo={this.natRoomToResidentRepo}
                        natCondominiumGroupRepo={this.natCondominiumGroupRepo}
                        natScheduleRepo={this.natScheduleRepo}
                        natEventRepo={this.natEventRepo}
                        natRidgeRepo={this.natRidgeRepo}
                        natPasswordRepo={this.natPasswordRepo}
                        natMessageRepo={this.natMessageRepo}
                        natCurrentDateTimeRepo={this.natCurrentDateTimeRepo}
                        natHolidayMasterRepo={this.natHolidayMasterRepo}
                        natLifeNoteRepo={this.natLifeNoteRepo}
                        natSessionRepo={this.natSessionRepo}
                        natLoginBeforeMessageRepo={this.natLoginBeforeMessageRepo}
                        natClosedSettingRepo={this.natClosedSettingRepo}
                        natMenuMasterRepo={this.natMenuMasterRepo}
                        natUseFunctionMasterRepo={this.natUseFunctionMasterRepo}
                        natCondominiumAuthoritySettingRepo=
                            {this.natCondominiumAuthoritySettingRepo}
                        natOwnerCondominiumRepo={this.natOwnerCondominiumRepo}
                        natApartAssocInfoRepo={this.natApartAssocInfoRepo}
                        natFacilityRepo={this.natFacilityRepo}
                        natRoomNumberRepo={this.natRoomNumberRepo}
                        adminUserRepo={this.adminUserRepo}
                        natFacilityReserveRepo={this.natFacilityReserveRepo}
                        holidaysRepo={this.holidaysRepo}
                        natBulletinBoardRepo={this.natBulletinBoardRepo}
                        personalInfoExtractHistoryRepo={this.personalInfoExtractHistoryRepo}
                        natAreaCodeRepo={this.natAreaCodeRepo}
                        natMaintenanceSettingMasterRepo=
                            {this.natMaintenanceSettingMasterRepo}
                        natExtractHistoryRepo={this.natExtractHistoryRepo}
                        assocManagementRepo={this.assocManagementRepo}
                        assocDirectorRepo={this.assocDirectorRepository}
                        applicationRepo={this.applicationRepo}
                        fileRepo={this.fileRepo}
                        assocWorkReportRepo={this.assocWorkReportRepo}
                        ownershipTransfersRepo={this.ownershipTransfersRepo}
                        residentUserRepo={this.residentUserRepo}
                        disasterRepo={this.disasterRepo}
                        adminGeneralMeetingRepo={this.adminGeneralMeetingRepo}
                    />
                )
            } else if (matchPath({path: '/resident', end: false}, location.pathname)) {
                return (
                    <AppResident
                        location={location}
                        condominiumsRepo={this.condominiumsRepo}
                        facilitiesRepo={this.facilitiesRepo}
                        reservationsRepo={this.reservationsRepo}
                        adminAuthRepo={this.adminAuthRepo}
                        equipmentsRepo={this.equipmentsRepo}
                        holidaysRepo={this.holidaysRepo}
                        natTokenRepo={this.natTokenRepo}
                        natCondominiumRepo={this.natCondominiumRepo}
                        natAdminUserRepo={this.natAdminUserRepo}
                        natResidentUserRepo={this.natResidentUserRepo}
                        natRoomToResidentRepo={this.natRoomToResidentRepo}
                        natCondominiumGroupRepo={this.natCondominiumGroupRepo}
                        natRidgeRepo={this.natRidgeRepo}
                        natRoomNumberRepo={this.natRoomNumberRepo}
                        natPasswordRepo={this.natPasswordRepo}
                        natMessageRepo={this.natMessageRepo}
                        natCurrentDateTimeRepo={this.natCurrentDateTimeRepo}
                        natLoginRepo={this.natLoginRepo}
                        natSessionRepo={this.natSessionRepo}
                        natLoginBeforeMessageRepo={this.natLoginBeforeMessageRepo}
                        natmenuMasterRepo={this.natMenuMasterRepo}
                        natLifeNoteRepo={this.natLifeNoteRepo}
                        natEventRepo={this.natEventRepo}
                        natHolidayMasterRepo={this.natHolidayMasterRepo}
                        natApartAssocInfoRepo={this.natApartAssocInfoRepo}
                        natFacilityReserveRepo={this.natFacilityReserveRepo}
                        natBulletinBoardRepo={this.natBulletinBoardRepo}
                        natEnvSettingRepo={this.natEnvSettingRepo}
                        natSsoRepo={this.natSsoRepo}
                        natCommunicationPlatformRepo={this.natCommunicationPlatformRepo}
                        meetingRepoForResident={this.meetingRepoForResident}
                        applicationRepo={this.applicationRepo}
                        fileRepo={this.fileRepo}
                        assocWorkReportRepo={this.assocWorkReportRepo}
                        ownershipTransfersRepo={this.ownershipTransfersRepo}
                        campaignRepo={this.campaignRepo}
                        natAuthorityRepo={this.natAuthorityRepo}
                        bankAccountInfoRepo={this.bankAccountInfoRepo}
                        billingAmountFixInfoRepo={this.billingAmountFixInfoRepo}
                        useFunctionMasterRepo={this.useFunctionMasterRepo}
                        sutekiNetPlusRepo={this.sutekiNetPlusRepo}
                        disasterRepo={this.disasterRepo}
                        residentGeneralMeetingRepo={this.residentGeneralMeetingRepo}
                    />
                )
            } else if (matchPath({path: '/guest', end: false}, location.pathname)) {
                return (
                    <AppGuest
                        natSessionRepo={this.natSessionRepo}
                        condominiumsRepo={this.natCondominiumRepo}
                        natCurrentDateTimeRepo={this.natCurrentDateTimeRepo}
                        ownershipTransfersRepo={this.ownershipTransfersRepo}
                        holidaysRepo={this.holidaysRepo}
                        guestLoginRepo={this.natGuestLoginRepo}
                        twoFactorAuthRepo={this.natTwoFactorAuthRepo}
                    />
                )
            } else {
                return <Navigate to="/resident/login" replace/>
            }
        }
        return <>{renderApp()}</>
    }

    render(): ReactElement {
        jaLocale.options = {weekStartsOn: 0}
        return (
            <React.Fragment>
                <NoSsr>
                    <LocalizationProvider dateAdapter={ExtendedDateFnsUtilsUtils} adapterLocale={jaLocale}>
                        <BrowserRouter>
                            <ScrollToTop>
                                <this.AppSelector/>
                            </ScrollToTop>
                        </BrowserRouter>
                    </LocalizationProvider>
                </NoSsr>
            </React.Fragment>
        )
    }
}
